// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ax-4";
export var collapsed = "_ax-1";
export var headerBar = "_ax-0";
export var leftHeaderContent = "_ax-3";
export var subjectContainer = "_ax-2";